import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { AudioVideoSubcategoryTypeEnum } from '../interfaces/audio-video.model';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.Writing,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Writing',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>These videos show you how you could answer some of your writing questions — we\'ve used our best handwriting especially!</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Writing Video Solutions',
        Intro:
          'Use these videos to help you find out how to approach some of the writing questions in your book.',
        LeftSections: [
          {
            Header: 'Section One — General Stuff',
            Subcategories: [
              {
                Name: 'Questions and Being Polite —Q1',
                ShortName: 'Questions-and-Being-Polite-Q1',
                Link: 'https://www.youtube.com/embed/U4J5SjAibYs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Three — Healthy Living',
            Subcategories: [
              {
                Name: 'Physical & Mental Wellbeing and Illness & Treatments — Q4',
                ShortName: 'Physical-and-Mental-Wellbeing-and-Illness-and-Treatments-Q4',
                Link: 'https://www.youtube.com/embed/5PmNPbNHT3Q?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Four — Free-time Activities',
            Subcategories: [
              {
                Name: 'Music and Sport — Q3 (Foundation)',
                ShortName: 'Music-and-Sport-Q3-Foundation',
                Link: 'https://www.youtube.com/embed/mmk1w0U72p0?rel=0&modestbranding=1',
              },
              {
                Name: 'Music and Sport — Q3 (Higher)',
                ShortName: 'Music-and-Sport-Q3-Higher',
                Link: 'https://www.youtube.com/embed/m6lZntnAICk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 1 and 2 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 1 and 2 Mixed Practice Foundation — Q4',
                ShortName: 'Themes-1-and-2-Mixed-Practice-Foundation-Q4',
                Link: 'https://www.youtube.com/embed/K3VBOocOjRA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Seven — Social Media and Technology',
            Subcategories: [
              {
                Name: 'Technology, The Internet and Gaming — Q5',
                ShortName: 'Technology-The-Internet-and-Gaming-Q5',
                Link: 'https://www.youtube.com/embed/z0I771pDX50?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Reading,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Reading',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Watch us work through some of the reading questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Reading Video Solutions',
        Intro:
          'Our experts work through some of the reading questions in your book — take your pick!',
        LeftSections: [
          {
            Header: 'Section Two — Identity and Relationships',
            Subcategories: [
              {
                Name: 'About Yourself and My Family & Friends — Q4',
                ShortName: 'About-Yourself-and-My-Family-and-Friends-Q4',
                Link: 'https://www.youtube.com/embed/O3D1u5aAVnc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 3 and 4 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 3 and 4 Mixed Practice Both Tiers — Q3',
                ShortName: 'Themes-3-and-4-Mixed-Practice-Both-Tiers-Q3',
                Link: 'https://www.youtube.com/embed/3kggf6k1LFo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eight — School',
            Subcategories: [
              {
                Name: 'School Pressures and Difficulties — Q3',
                ShortName: 'School-Pressures-and-Difficulties-Q3',
                Link: 'https://www.youtube.com/embed/Ktxy9y5lTzA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Ten — Travel and Tourism',
            Subcategories: [
              {
                Name: 'Where to Go and Accommodation & Travel — Q3',
                ShortName: 'Where-to-Go-and-Accommodation-and-Travel-Q3',
                Link: 'https://www.youtube.com/embed/sUzGa1c7v-8?rel=0&modestbranding=1',
              },
              {
                Name: 'What to Do — Q1',
                ShortName: 'What-to-Do-Q1',
                Link: 'https://www.youtube.com/embed/rgmVOQ8JhZs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Theme 5 and 6 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 5 and 6 Mixed Practice Higher — Q7',
                ShortName: 'Themes-5-and-6-Mixed-Practice-Higher-Q7',
                Link: 'https://www.youtube.com/embed/Ho9TPN4YvI4?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Listening',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>You\'ve hit the listening jackpot — here\'s all the audio you\'ll need for your listening questions.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio for all listening questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Audio',
      Intro: 'Choose a listening question in your book and find the matching audio track below!',
      ProductTitle: 'GCSE Edexcel French Exam Practice Workbook',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/01-listening-track-01-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/02-listening-track-02-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/03-listening-track-03-questions-and-being-polite.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/04-listening-track-04-questions-and-being-polite.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/05-listening-track-05-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/06-listening-track-06-about-yourself-and-my-family-&-friends.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/07-listening-track-07-describing-people-and-relationships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/08-listening-track-08-role-models-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/09-listening-track-09-role-models-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/10-listening-track-10-physical-&-mental-wellbeing-and-illnesses-&-treatments.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/11-listening-track-11-food.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/12-listening-track-12-food.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/13-listening-track-13-music-and-sport.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/14-listening-track-14-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/15-listening-track-15-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/16-listening-track-16-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/17-listening-track-17-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/18-listening-track-18-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/19-listening-track-19-where-you-live-and-the-home.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/20-listening-track-20-the-local-area.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/21-listening-track-21-shopping-directions-and-weather.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/22-listening-track-22-the-natural-world.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/23-listening-track-23-environmental-problems-equality-&-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/24-listening-track-24-technology-the-internet-and-gaming.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/25-listening-track-25-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/26-listening-track-26-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/27-listening-track-27-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/28-listening-track-28-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/29-listening-track-29-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/30-listening-track-30-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/31-listening-track-31-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/32-listening-track-32-school-subjects-and-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/33-listening-track-33-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/34-listening-track-34-education-post-16-and-career-choices-&-ambitions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/35-listening-track-35-where-to-go-and-accommodation-&-travel.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/36-listening-track-36-what-to-do.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/37-listening-track-37-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/38-listening-track-38-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/39-listening-track-39-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/40-listening-track-40-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/listening/41-listening-track-41-mixed-practice-higher.mp3',
      ],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Speaking,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio and videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Speaking',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>All the audio for your speaking questions and some example answers from our speaking pros — let\'s go!</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio and example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro:
        'Check out the audio for the speaking questions in your book or take a look at our handy videos, which give you some example answers.',
      Title: 'Speaking Audio and Video Solutions',
      LeftSections: [
        {
          Title: 'Speaking Audio',
          Header: '',
          Subcategories: [
            {
              Name: 'Audio Support',
              Link: '',
              LinkName: '',
              Description:
                'Choose a speaking question in your book and find the matching audio track below!',
              Type: AudioVideoSubcategoryTypeEnum.Audio,
              TrackFilePaths: [
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/01-speaking-track-01-opinions.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/02-speaking-track-02-describing-people-and-relationships.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/03-speaking-track-03-physical-&-mental-wellbeing-and-illnesses-&-treatments.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/04-speaking-track-04-food.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/05-speaking-track-05-cinema-theatre-tv-going-out-&-other-hobbies.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/06-speaking-track-06-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/07-speaking-track-07-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/08-speaking-track-08-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/09-speaking-track-09-shopping-directions-and-weather.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/10-speaking-track-10-environmental-problems-equality-&-social-issues.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/11-speaking-track-11-technology-the-internet-and-gaming.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/12-speaking-track-12-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/13-speaking-track-13-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/14-speaking-track-14-mixed-practice-both-tiers.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/15-speaking-track-15-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/16-speaking-track-16-school-subjects-and-school-life.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/17-speaking-track-17-education-post-16-and-career-choices-&-ambitions.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/18-speaking-track-18-where-to-go-and-accommodation-&-travel.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/19-speaking-track-19-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/20-speaking-track-20-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FEQ42/Audio/speaking/21-speaking-track-21-mixed-practice-both-tiers.mp3',
              ],
            },
          ],
        },
        {
          Title: 'Speaking Video Solutions',
          Header: 'Section Two — Identity and Relationships',
          Subcategories: [
            {
              Name: 'Describing People and Relationships — Q4',
              Link: 'https://www.youtube.com/embed/wPuKLAyWvLI?rel=0&modestbranding=1',
              LinkName: 'Describing-People-and-Relationships-Q4',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Four — Free-time Activities',
          Subcategories: [
            {
              Name: 'Cinema, Theatre, TV, Going Out & Other Hobbies — Q3',
              Link: 'https://www.youtube.com/embed/za2vV-M8gcA?rel=0&modestbranding=1',
              LinkName: 'Cinema-Theatre-TV-Going-Out-and-Other-Hobbies-Q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Themes 1 and 2 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Themes 1 and 2 Mixed Practice Higher — Q2',
              Link: 'https://www.youtube.com/embed/uLm21pLo90s?rel=0&modestbranding=1',
              LinkName: 'Themes-1-and-2-Mixed-Practice-Higher-Q2',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Five — Places in Town',
          Subcategories: [
            {
              Name: 'Shopping, Directions and Weather — Q4',
              Link: 'https://www.youtube.com/embed/Bh7wymosJUE?rel=0&modestbranding=1',
              LinkName: 'Shopping-Directions-and-Weather-Q4',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Themes 3 and 4 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Themes 3 and 4 Mixed Practice Foundation — Q1',
              Link: 'https://www.youtube.com/embed/e5WGtwPvZ0w?rel=0&modestbranding=1',
              LinkName: 'Themes-3-and-4-Mixed-Practice-Foundation-Q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Themes 5 and 6 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Themes 5 and 6 Mixed Practice Foundation — Q7',
              Link: 'https://www.youtube.com/embed/ppl-9-tUGbg?rel=0&modestbranding=1',
              LinkName: 'themes-5-6-foundation',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
      ],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: 'Download audio transcripts and mark schemes here.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Downloadable extras',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: 'We\'ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you\'ve hit any snags, you\'ll find the answers you need here too.',
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<h3>Speaking</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FEQ42/PDFs/cgp-gcse-french-speaking-transcripts-pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Transcripts</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FEQ42/PDFs/cgp-gcse-french-speaking-mark-schemes.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Mark Schemes</a></p>\n' +
        '\n' +
        '<h3>Listening</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FEQ42/PDFs/cgp-gcse-french-listening-transcripts-pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Transcripts</a></p>\n' +
        '\n' +
        '<h3>Writing</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FEQ42/PDFs/cgp-gcse-french-writing-mark-schemes-pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Mark Schemes</a></p>\n' +
        '\n' +
        '<p>&nbsp;</p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There\'s plenty more revision where this came from. Take a look at some of our other books!',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: '(you\'ll find some excellent jokes along the way)',
    },
  },
];
